import { MenuItem } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { styled } from "@mui/material/styles";

import { Button } from "../../../../../components/Form";


interface ActionMenuItemProp {
  type: 'approve' | 'decline' | 'sendToReview';
}
const getMenuItemColor = (type: 'approve' | 'decline' | 'sendToReview') => {
  switch(type){
    case 'approve':
      return '#32D583'
    case 'decline':
      return '#F97066'
    default: return '#667085'
  }
}

export const ActionMenuItem = styled(MenuItem)(({ type }: ActionMenuItemProp) => ({
  color: getMenuItemColor(type),
  font: "500 12px/24px Manrope !important",
}));

export const SendReviewButton = styled(Button)(() => ({
  font: "700 14px/24px Inter",
  width: 156,
}));

export const ViewActivityButton = styled(Button)(() => ({
  border: "1px solid #308cdb",
  borderRadius: 8,
}))

export const ButtonsWrapperWhenIsMobile = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  gap: "1rem",
}));

const styles = makeStyles(() => ({
  mt40: {
    marginTop: "2.5rem",
  }
}))


export default styles;
